<script lang="ts">
  import SvelteMarkdown from "svelte-markdown";
  import {
    Button,
    ComfortCol,
    Hor,
    ModalDialog,
    Spacer,
    WithResource,
  } from "$components";
  import api, { fromApi } from "$parkito-api";
  import { Form } from "$shared/lib/validation_next";

  const {
    onClose,
    agreementId,
    checkbox,
  }: {
    onClose: () => void;
    agreementId: string;
    checkbox: Form.Checkbox<boolean>;
  } = $props();
  const termsCall = fromApi(() =>
    api.getAgreementFullTerms({ path: { id: agreementId } })
  );
  $termsCall.load();
</script>

<ModalDialog title="Villkor" onBackdropPressed={onClose}>
  <ComfortCol>
    <div
      class="w-full markdown list-normal word-break overflow-y-scroll max-h-[70vh]"
    >
      <WithResource api={termsCall}>
        {#snippet child(terms)}
          {#each terms as term}
            <SvelteMarkdown source={term.content} />
          {/each}
        {/snippet}
      </WithResource>
    </div>
    <Spacer minSpace="s" />
    <Hor>
      <Button type="ghost" text="Stäng" onClick={onClose}></Button>
      <Spacer />
      <Button
        text="Godkänn vilkoren"
        onClick={() => {
          checkbox.input.set(true);
          onClose();
        }}
      ></Button>
    </Hor>
  </ComfortCol>
</ModalDialog>
